module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Db-Ee-Ga.39f887a7.png";